
import bus from "@/script/core/util/Bus";
import { MenuService } from "@/script/apps/system/service/MenuService";
import { MenuData } from "@/script/core/base/MenuData";
import { Menu as MenuEntity } from "@/script/apps/system/entity/SystemEntity";
import { ElMessage } from "element-plus";
import { Options, Vue } from "vue-class-component";
import store from "@/store";
import { TabItem } from "@/store/TabItem";

@Options({})
export default class Menu extends Vue {
  private menuHeight?: number;
  private menus: Menu[] = [];
  private activeName = "/index";

  beforeCreate() {
    this.menuHeight = document.body.clientHeight - 90;
  }

  created() {    
    const self = this;
    const menuService = new MenuService();
    menuService.loadMenuList(
      store.getters.loginUser.id,
      function(data: any) {
        self.menus = data;
      },
      function(error: Error) {
        ElMessage.error("读取菜单失败，失败原因：" + error.message);
      }
    );
    bus.on("tab-active", (data: any) => {
      this.activeName = data;
    });
  }

  onClick(menu: MenuEntity) {
    const menuData: MenuData = {
      name: String(menu.url),
      path: String(menu.url),
      title: String(menu.name),
      isClose: true
    };
    bus.emit("menu-select", menuData);
  }
}
